module.exports = __webpack_public_path__ + "static/media/20210410_180459_918_IMG_0267.22124dd1.jpg";